import { render, staticRenderFns } from "./ReverseLogisticsAdd.vue?vue&type=template&id=51d4094a&scoped=true"
import script from "./ReverseLogisticsAdd.vue?vue&type=script&lang=js"
export * from "./ReverseLogisticsAdd.vue?vue&type=script&lang=js"
import style0 from "./ReverseLogisticsAdd.vue?vue&type=style&index=0&id=51d4094a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d4094a",
  null
  
)

export default component.exports